/**
 * Tag Rules › Hours — what an hour means here, above the rules list.
 * For Media Devoted | Created By Ciro Autiero
 */

import { Clock } from 'lucide-react';

export function HourTagsNotice() {
  return (
    <div
      className="flex items-start gap-3 rounded-xl border border-border bg-card px-4 py-3 text-sm"
      data-testid="hour-tags-notice"
    >
      <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
      <p className="text-muted-foreground">
        <span className="font-medium text-foreground">Hours are the recipients&apos; local clock</span>{' '}
        (the country&apos;s timezone). An hour is the hour of the visit, not of the send. Tags are
        judged per campaign over whole days; an hour under the minimum visits is{' '}
        <span className="font-medium text-foreground">Unknown</span> and the Drop Generator never
        acts on it.
      </p>
    </div>
  );
}
